module.exports = __webpack_public_path__ + "img/top_11.615ad1da.png";